import IDoctorProfile from "../interfaces/doctor/IDoctorProfile"
import * as ActionTypes from "../constants/actionTypes"
import { AppTenants } from "../constants"
import { UPDATE_CURRENT_DOCTOR_TENANT } from "../constants/actionTypes"

function init(): AppTenants {
	return AppTenants.SUGARFIT
}

export const doctorTenantReducer = (state: AppTenants = init(), action: any): AppTenants => {
	switch (action.type) {
		case ActionTypes.UPDATE_CURRENT_DOCTOR_TENANT:
			return action.payload
		default:
			return state
	}
}
